import React from "react";
import PropTypes from "prop-types";

import { Creatable } from "react-select";

const CreatableSelect = ({
  value,
  isMulti,
  onChange,
  placeholder,
  label,
  name,
  disabled,
  options,
  formatCreateLabel,
  openMenuOnClick
}) => (
  <React.Fragment>
    {label ? (
      <label
        className={`control-label ${!label ? "hidden" : ""}`}
        htmlFor="creatable-select"
        style={{ textTransform: "uppercase" }}
      >
        {label}
      </label>
    ) : null}
    <Creatable
      id="creatable-select"
      name={name}
      className="react-select-container"
      classNamePrefix="react-select-container"
      fullwidth
      placeholder={placeholder}
      value={value}
      options={options}
      isClearable
      onChange={(v) => onChange(name, v)}
      isMulti={isMulti}
      menuPortalTarget={document.body}
      isDisabled={disabled}
      formatCreateLabel={() => formatCreateLabel}
      openMenuOnClick={openMenuOnClick}
    />
  </React.Fragment>
);

CreatableSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  formatCreateLabel: PropTypes.string,
  openMenuOnClick: PropTypes.bool
};

CreatableSelect.defaultProps = {
  placeholder: "Select",
  isMulti: true,
  options: [],
  openMenuOnClick: false
};

export default CreatableSelect;
